import { Navigation, CalendarCheck, MapPin } from "lucide-react";
import { MaskLines, Overline, Reveal } from "./Motion";
import { LOCATIONS } from "../../lib/site";

const LocationCard = ({ loc, i, onVisit }) => (
  <Reveal delay={i * 0.1} data-testid={`location-card-${loc.id}`}
    className="group overflow-hidden rounded-[28px] border border-white/10 bg-[#131924]">
    <div className="relative aspect-[16/10] overflow-hidden">
      <img src={loc.img} alt={loc.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#131924] via-[#131924]/30 to-transparent" />
      <span className="font-display absolute right-5 top-2 text-7xl sm:text-8xl font-bold text-outline leading-none">{loc.no}</span>
      <div className="absolute bottom-5 left-6 right-6">
        <p className="font-mono-k text-[11px] uppercase tracking-[0.25em] text-[#E3C45A]">Location 0{i + 1}</p>
        <h3 className="font-display mt-2 text-3xl sm:text-4xl font-semibold tracking-tight text-white">{loc.name}</h3>
      </div>
    </div>
    <div className="p-6 sm:p-7">
      <p className="flex items-start gap-2 text-slate-300"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#D4AF37]" />{loc.area}</p>
      <div className="mt-6 overflow-hidden rounded-2xl border border-white/10">
        <iframe title={`Map of ${loc.name}`} loading="lazy" referrerPolicy="no-referrer-when-downgrade"
          src={`https://maps.google.com/maps?q=${encodeURIComponent(loc.query)}&z=15&output=embed`}
          className="map-dark h-56 w-full" data-testid={`location-map-${loc.id}`} />
      </div>
      <div className="mt-6 flex flex-wrap gap-3">
        <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(loc.query)}`} target="_blank" rel="noreferrer"
          data-testid={`location-directions-${loc.id}`}
          className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-3 text-sm text-white hover:border-[#D4AF37]/50 hover:bg-white/5 transition-colors">
          <Navigation className="h-4 w-4 text-[#D4AF37]" /> Get Directions
        </a>
        <button onClick={() => onVisit(loc)} data-testid={`location-visit-${loc.id}`}
          className="btn-gold inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold">
          <CalendarCheck className="h-4 w-4" /> Book a Visit Here
        </button>
      </div>
    </div>
  </Reveal>
);

export const Locations = ({ onVisit }) => (
  <section id="locations" data-testid="locations-section" className="relative bg-[#0B0F17] py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Overline>Our Locations</Overline>
      <MaskLines className="font-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.02] text-white"
        lines={["Two addresses.", <span className="text-gold">Both in the heart of Noida.</span>]} />
      <div className="mt-16 grid gap-6 lg:grid-cols-2">
        {LOCATIONS.map((loc, i) => <LocationCard key={loc.id} loc={loc} i={i} onVisit={onVisit} />)}
      </div>
    </div>
  </section>
);
